/**
 * @generated SignedSource<<c871442ba7271270a042763e0af651b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightEditPriceHistory_flight$data = {
  readonly history: {
    readonly " $fragmentSpreads": FragmentRefs<"FlightPriceHistoryTable_history">;
  };
  readonly id: string;
  readonly " $fragmentType": "FlightEditPriceHistory_flight";
};
export type FlightEditPriceHistory_flight$key = {
  readonly " $data"?: FlightEditPriceHistory_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightEditPriceHistory_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./FlightEditPriceHistoryRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "FlightEditPriceHistory_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "FlightPriceConnection",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightPriceHistoryTable_history"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "663fc3318825af4ab8b0ef14a04e7a03";

export default node;
